import { Component } from '@theme/component';
import { estimate, arrivalLabel, zonedNow, DAY_ACC } from '@theme/delivery-date';

/**
 * PDP delivery estimate — "order now, arrives <day>".
 *
 * Computed in the browser, never in Liquid: Shopify caches rendered pages, so a
 * server-rendered date would keep promising yesterday's answer to today's visitor.
 * The date rules themselves live in @theme/delivery-date, which is covered by tests.
 */
class DeliveryEstimate extends Component {
  setup() {
    this.cutoffMinutes = Number(this.dataset.cutoffHour || 11) * 60;
    this.holidays = new Set(
      (this.dataset.holidays || '').split(',').map((s) => s.trim()).filter(Boolean)
    );

    const raw = this.querySelector('[data-variant-availability]');
    try {
      this.availability = raw ? JSON.parse(raw.textContent) : {};
    } catch {
      this.availability = {};
    }
    this.available = this.dataset.available === 'true';

    this.onVariant = (event) => {
      // An unknown id means we cannot vouch for stock, so stay quiet rather than
      // promise a delivery date for something that may not ship.
      this.available = this.availability[String(event.detail.variantId)] === true;
      this.render();
    };
    document.addEventListener('variant:changed', this.onVariant);

    this.render();
    // Re-render so a shopper sitting on the page across the cut-off sees the promise
    // change instead of a stale one, and the countdown never freezes.
    this.timer = setInterval(() => this.render(), 30000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('variant:changed', this.onVariant);
  }

  render() {
    if (!this.available) {
      this.hidden = true;
      return;
    }

    const { today, ship, arrive, shipsToday, minutesLeft } = estimate({
      now: zonedNow(),
      cutoffMinutes: this.cutoffMinutes,
      holidays: this.holidays,
    });

    this.querySelector('[data-arrival]').textContent = arrivalLabel(today, arrive);

    const note = this.querySelector('[data-dispatch]');
    if (shipsToday) {
      const h = Math.floor(minutesLeft / 60);
      const m = minutesLeft % 60;
      note.textContent = `Poručite u narednih ${h > 0 ? `${h} h ${m} min` : `${m} min`} i šaljemo danas.`;
    } else {
      note.textContent = `Šaljemo u ${DAY_ACC[new Date(ship).getUTCDay()]}, prvog radnog dana.`;
    }

    this.hidden = false;
  }
}

customElements.define('delivery-estimate', DeliveryEstimate);
